import { useMemo, useState } from 'react';
import { BiomarkerClassification, type BiomarkerResult } from '@/api/generated-catch-backend/model';
import type { FilterableClassification } from '../components/biomarker-filter/biomarker-filter';

export function useBiomarkerFilter(biomarkers: BiomarkerResult[]) {
  const [selectedFilter, setSelectedFilter] = useState<FilterableClassification | null>(null);

  // Calculate which classifications exist in the biomarkers
  const availableClassifications = useMemo(() => {
    const classifications = new Set<FilterableClassification>();
    biomarkers.forEach((biomarker) => {
      if (biomarker.classification === BiomarkerClassification.optimal) {
        classifications.add('optimal');
      } else if (biomarker.classification === BiomarkerClassification.normal) {
        classifications.add('normal');
      } else if (biomarker.classification === BiomarkerClassification.out_of_range) {
        classifications.add('out_of_range');
      } else if (biomarker.classification === BiomarkerClassification.critical) {
        classifications.add('critical');
      }
    });
    return classifications;
  }, [biomarkers]);

  // Filter biomarkers based on selected filter
  const filteredBiomarkers = useMemo(() => {
    if (!selectedFilter) {
      return biomarkers;
    }

    return biomarkers.filter((biomarker) => {
      if (biomarker.classification === BiomarkerClassification.optimal) {
        return selectedFilter === 'optimal';
      } else if (biomarker.classification === BiomarkerClassification.normal) {
        return selectedFilter === 'normal';
      } else if (biomarker.classification === BiomarkerClassification.out_of_range) {
        return selectedFilter === 'out_of_range';
      } else if (biomarker.classification === BiomarkerClassification.critical) {
        return selectedFilter === 'critical';
      }
      return true;
    });
  }, [biomarkers, selectedFilter]);

  return {
    selectedFilter,
    setSelectedFilter,
    availableClassifications,
    filteredBiomarkers,
  };
}
